const returnFirstArg = (x) => x;

const TOKEN = 'Xm4faXb5SijhFRLlIPnHh6MZmXMpIUHH';

export default class Service {
  constructor(api, options = {}) {
    this.api = api;
    this.api.use({
      headers: {
        'Access-Token': TOKEN,
      } });
    const { afterParser = returnFirstArg } = options;
    this.afterParser = afterParser;
  }

  find(params) {
    return this.api.get(params).then(this.afterParser);
  }

  update(data = {}, options = {}) {
    return this.api.post(data, options).then(this.afterParser);
  }

  modify(data = {}, options = {}) {
    return this.api.patch(data, options).then(this.afterParser);
  }

  insert(data = {}, options = {}) {
    return this.api.put(data, options).then(this.afterParser);
  }

  remove(params = {}) {
    return this.api.delete(params).then(this.afterParser);
  }
}
